module.exports = __webpack_public_path__ + "img/projectManagement_sign.71923039.png";